import { render } from "./DialogBGColor.vue?vue&type=template&id=2afed009"
import script from "./DialogBGColor.vue?vue&type=script&lang=js"
export * from "./DialogBGColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__